import { render } from "./StagesMenu.vue?vue&type=template&id=5729dd6c&scoped=true"
import script from "./StagesMenu.vue?vue&type=script&lang=js"
export * from "./StagesMenu.vue?vue&type=script&lang=js"

import "./StagesMenu.vue?vue&type=style&index=0&id=5729dd6c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5729dd6c"]])

export default __exports__